import { addNotification } from './addNotification'
import { useNotificationStore } from '~/stores/notification'

export const SESSION_EXPIRED_MESSAGE =
  'Your session has expired. Please log in again.'

/**
 * Tell the user their session has ended -- ONCE.
 *
 * ⚠ One expired token reaches the user through several 403s at once, and each
 * used to add its own copy of this notification. A single navigation produced
 * three: httpGet's 403 case runs handleAsyncDataErrors itself and then rethrows,
 * the caller's catch hands the same error to handleAsyncDataErrors again, and
 * the auth middleware's isAuthenticated() notifies on its own. Concurrent reads
 * (a page's asyncData beside its cards' select lists) add more.
 *
 * Deduplicated against what is ON SCREEN rather than with a module latch: the
 * notification has no auto-remove, so it stays until dismissed, and once it is
 * dismissed a later expiry is news again. A latch would need resetting at login,
 * and forgetting to is how a second expiry goes silent.
 */
export function notifySessionExpired(statusCode?: number | null) {
  const isAlreadyShown = useNotificationStore().notifications.some(
    (notification) => notification.message === SESSION_EXPIRED_MESSAGE
  )
  if (isAlreadyShown) {
    return
  }
  addNotification({
    type: 'warning',
    message: SESSION_EXPIRED_MESSAGE,
    statusCode: statusCode ?? undefined,
  })
}
